import React from "react";
import "./styles/font.css";
import ReactDOM from "react-dom";
import { Amplify } from "aws-amplify";
import App from "./App";
import { loadRuntimeConfig } from "./runtimeConfig";
import "./styles/index.css";
import "./styles/tailwind.css";

// Amplify is used for Cognito sign-in only; the data API is utils/apiClient.
loadRuntimeConfig()
  .then((config) => {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: config.userPoolId,
          userPoolClientId: config.userPoolWebClientId,
          loginWith: { email: false, username: true },
          mfa: { status: "optional", totpEnabled: true },
        },
      },
    });
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById("root"),
    );
  })
  .catch((error) => {
    console.error("[config] failed to load /config.json", error);
    document.getElementById("root").textContent =
      "設定を読み込めませんでした。ページを再読み込みしてください。";
  });
